import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatINR(amount) {
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(amount || 0);
}

export function formatDate(d) {
  if (!d) return '—';
  const dt = typeof d === 'string' ? new Date(d) : d;
  return dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function pad(n) { return String(n).padStart(2, '0'); }
export function hourLabel(h) { return `${pad(h)}:00`; }
export function slotLabel(start, dur) { return `${pad(start)}:00 – ${pad(start + dur)}:00`; }

// Turns any shape the backend can send an error "detail" in into one
// human-readable string. A plain string and `{ detail: "..." }` were the
// only shapes every page's `e.response?.data?.detail` handling actually
// worked for — a FastAPI/Pydantic 422 validation error's `detail` is an
// ARRAY of `{ type, loc, msg, ... }` objects instead, which every toast
// call in this app passes straight into <div>{description}</div> as a
// child, throwing "Objects are not valid as a React child" instead of
// showing the validation message. The new password policy (min length +
// complexity) makes a 422 far more likely to happen on Register/Reset
// Password/staff creation than before, so this needed fixing alongside it
// rather than after — mirrors the mobile app's identical helper
// (src/lib/api.ts's errorMessage) which fixed the same bug there.
export function errorMessage(detail, fallback = 'Something went wrong') {
  if (typeof detail === 'string') return detail;
  if (detail == null) return fallback;
  const inner = detail.detail !== undefined ? detail.detail : detail;
  if (typeof inner === 'string') return inner;
  if (Array.isArray(inner)) {
    const msgs = inner.map((e) => (e && typeof e === 'object' && typeof e.msg === 'string' ? e.msg : null)).filter(Boolean);
    if (msgs.length) return msgs.join(' ');
  }
  if (inner && typeof inner === 'object' && typeof inner.msg === 'string') return inner.msg;
  return fallback;
}
